import React, { useEffect, useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import ResumeFields from './resumeComponents/ResumeFields'
import Moment from "react-moment";
import Wmbutton from '../ui-components/wm-button/Wm.button'
import Skills from '../Components/Skills/Skills'
import { connect } from "react-redux";
import { getResumeData, deleteResume } from "../functions/apis"
import WmModals from "../modals/Wm.Modals";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Link, useLocation, useHistory } from 'react-router-dom'
import { encode, decode } from "base-64";
import { setResumeDataEdit, addSkills, checkAllPersonalDetail, checkAllExtra, checkAllCertificate, checkAllPublication, addHobbies, checkAllProject, addSkillsTitle, checkAllWork, checkAllEducation, addSkillsRange, checkEducation, checkProject, checkWork, checkExtra, checkPublic, checkCert, skillsReset, checkLinkd, checkDrib, checkBe, checkPin, checkInsta, checkYt, checkTw, skillsDelete, checkProfile, checkBio, checkFullName, checkAddress, checkPhone, checkEmail, checkFb } from "../services/actions/actions"
import ResumePreview from './Preview/ResumePreview';
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import SkillPills from '../Components/Skills/SkillPills';
import HobbiesPills from './resumeComponents/HobbiesPills';
import Hobbies from './resumeComponents/Hobbies';
function EditResume({ resume, getResumeDatas, checkAllPersonalDetails, checkAllExtras, checkAllCertificates, checkAllProjects, checkAllPublications, checkAllWorks, addSkill, checkAllEducations, checkEducations, checkProjects, checkWorks, checkExtras, checkPublics, checkCerts, addSkillsTitles, checkLinkds, checkDribs, checkBes, checkPins, checkInstas, checkYts, checkTws, addSkillsRanges, skillsResets, skillsDeletes, checkProfiles, checkBios, checkFullNames, checkAddresss, checkPhones, checkEmails, checkFbs, handleAddHobbies, handleAddSkills }) {
    const [isDeleteResumeModal, setDeleteResumeModal] = useState(false)
    let history = useHistory();
    let { pathname } = useLocation();
    let url = pathname.split("/").pop()
    let urlDecoded = decode(url)
    const [isPreview, setIsPreview] = useState(false)
    const [tabIndex, setTabIndex] = useState('');
    useEffect(() => {
        if (urlDecoded === 'about-me') {
            setTabIndex(0)
        } else if (urlDecoded === 'education') {
            setTabIndex(1)
        } else if (urlDecoded === 'work') {
            setTabIndex(2)
        } else if (urlDecoded === 'books') {
            setTabIndex(3)
        } else if (urlDecoded === 'certificate') {
            setTabIndex(4)
        } else if (urlDecoded === 'extra-curricular') {
            setTabIndex(5)
        } else if (urlDecoded === 'projects') {
            setTabIndex(6)
        } else if (urlDecoded === 'hobbies') {
            setTabIndex(7)
        } else if (urlDecoded === 'skills') {
            setTabIndex(8)
        }
    }, [pathname])
    useEffect(() => {
        getResumeData()
            .then(function (res) {
                getResumeDatas(res.data)
            })
            .catch(function (err) {
                console.log(err)
            })
    }, [])
    const preview = () => {
        if (resume.education.some((val) => val.status === true) || resume.work.some((val) => val.status === true) || resume.publication.some((val) => val.status === true) || resume.certificate.some((val) => val.status === true)) {
            setIsPreview(true)
        } else {
            return null
        }
    }
    const [isDeleting, setIsDeleting] = useState(false)
    const deleteResumeModal = () => {
        setIsDeleting(true)
        deleteResume().then(function (res) {
            setIsDeleting(false)
            window.location.assign('/')
        })
            .catch(function (err) {
                console.log(err)
                setIsDeleting(false)
            })
    }
    return (
        <div>
            {isPreview ? <div className="mt-24"><ResumePreview resumeData={resume} onClickBack={() => setIsPreview(false)} /></div> :
                <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
                    <div className="max-w-full md:max-w-6xl container mt-24">
                        <div className="row">
                            <div className="col-md-12">
                                <div className='resume-tab'>
                                    <TabList className="w-full flex justify-between overflow-auto whitespace-nowrap space-x-5 md:space-x-0">
                                        <Tab className="text-gray-400 hover:text-black cursor-pointer manpro font-semibold mb-2 relative inline">
                                            <Link to={`/editresume/${encode('about-me')}`} className="no-underline">
                                                About me
                                            </Link>
                                        </Tab>
                                        <Tab className="text-gray-400 hover:text-black cursor-pointer manpro font-semibold mb-2 relative inline">
                                            <Link to={`/editresume/${encode('education')}`} className="no-underline">
                                                Education
                                            </Link>
                                        </Tab>
                                        <Tab className="text-gray-400 cursor-pointer manpro font-semibold mb-2 relative inline">
                                            <Link to={`/editresume/${encode('work')}`} className="no-underline">
                                                Work
                                            </Link>
                                        </Tab>
                                        <Tab className="text-gray-400 cursor-pointer manpro font-semibold mb-2 relative inline">
                                            <Link to={`/editresume/${encode('books')}`} className="no-underline">
                                                Publication & Books
                                            </Link>
                                        </Tab>
                                        <Tab className="text-gray-400 cursor-pointer manpro font-semibold mb-2 relative inline">
                                            <Link to={`/editresume/${encode('certificate')}`} className="no-underline">
                                                Certificate
                                            </Link>
                                        </Tab>
                                        <Tab className="text-gray-400 cursor-pointer manpro font-semibold mb-2 relative inline">
                                            <Link to={`/editresume/${encode('extra-curricular')}`} className="no-underline">
                                                Extra curricular
                                            </Link>
                                        </Tab>
                                        <Tab className="text-gray-400 cursor-pointer manpro font-semibold mb-2 relative inline">
                                            <Link to={`/editresume/${encode('projects')}`} className="no-underline">
                                                Projects
                                            </Link>
                                        </Tab>
                                        <Tab className="text-gray-400 cursor-pointer manpro font-semibold mb-2 relative inline">
                                            <Link to={`/editresume/${encode('hobbies')}`} className="no-underline">
                                                Hobbies & interest
                                            </Link>
                                        </Tab>
                                        <Tab className="text-gray-400 cursor-pointer manpro font-semibold mb-2 relative inline">
                                            <Link to={`/editresume/${encode('skills')}`} className="no-underline">
                                                Skills
                                            </Link>
                                        </Tab>
                                    </TabList>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="mb-3 space-x-3 border-t border-solid border-gray-300 pt-3">
                                    <Wmbutton className="px-4 rounded" label="Preview" type="button" color="primary" onClick={() => preview()} />
                                    <Wmbutton className="px-4 rounded" label="Delete" type="button" color="danger" onClick={() => setDeleteResumeModal(true)} />
                                </div>
                            </div>
                            <div className="col-md-12">
                            <div>
                                    <TabPanel>
                                        <Row className="mt-10">
                                            <Col md={12} className="mb-3">
                                                <div className="border-b border-gray-400 border-solid flex flex-col md:flex-row justify-between items-start md:items-center pb-3 space-y-5 md:space-y-0">
                                                    <div>
                                                        <span className="md:text-3xl manpro block text-gray-700 font-semibold text-2xl leading-8">Personal Detail</span>
                                                        <span className='text-xs md:text-sm text-gray-700'>Please select the fields need to be displayed on the resume</span>
                                                    </div>
                                                    <div>
                                                        <Wmbutton className="px-4 rounded ml-0 md:ml-0 text-sm" label={resume.isPersonDetailsChecked ? 'Unselect all' : 'Select all'} type="button" color="primary" onClick={() => checkAllPersonalDetails(resume.isPersonDetailsChecked ? 'UNCHECK' : 'CHECK')} />
                                                        <Wmbutton className="px-4 rounded ml-2 text-sm" label={'Next'} type="button" color="primary" onClick={() => history.push(`/editresume/${encode('education')}`)} />
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={3} className="mb-3">
                                                <ResumeFields onCheckChange={() => checkProfiles()} img={<div className="w-full h-40 flex items-center justify-center mt-4"><img src={resume.profilepicture.profilepicture} alt="pofile pic" className="w-full h-full object-cover object-top" /></div>} labelID='resume' userdetail checked={resume.profilepicture.status} />
                                            </Col>
                                            <Col md={9} className="mb-3">
                                                <ResumeFields onCheckChange={() => checkBios()} label={"Bio"} userdetail details={resume.bio.bio} checked={resume.bio.status} />
                                            </Col>
                                            <Col md={4} className="mb-3">
                                                <ResumeFields onCheckChange={() => checkFullNames()} label={"Full Name"} userdetail details={resume.fullname.fullname} checked={resume.fullname.status} />
                                            </Col>
                                            <Col md={4} className="mb-3">
                                                <ResumeFields onCheckChange={() => checkAddresss()} label={"Address"} userdetail details={resume.address.address} checked={resume.address.status} />
                                            </Col>
                                            <Col md={4} className="mb-3">
                                                <ResumeFields onCheckChange={() => checkPhones()} label={"Phone"} userdetail details={resume.phone.phone} checked={resume.phone.status} />
                                            </Col>
                                            <Col md={4} className="mb-3">
                                                <ResumeFields onCheckChange={() => checkEmails()} label={"E-mail"} userdetail details={resume.email.email} checked={resume.email.status} />
                                            </Col>
                                        </Row>
                                    </TabPanel>
                                    <TabPanel>
                                        <Row className="mb-8 mt-10">
                                            <Col md={12} className="mb-3">
                                                <div className="border-b border-gray-400 border-solid flex pb-3 justify-between items-start md:items-center space-y-5 md:space-y-0 flex-col md:flex-row">

                                                    <div>
                                                        <span className="md:text-3xl manpro block text-gray-700 font-semibold text-2xl leading-8">Education Detail
                                                        </span>
                                                        <span className='text-xs md:text-sm text-gray-700 '>Please select the fields need to be displayed on the resume</span>
                                                    </div>
                                                    <div>
                                                        <Wmbutton className="px-4 rounded ml-0 md:ml-0 text-sm" label={resume.isEducationChecked ? 'Unselect all' : 'Select all'} type="button" color="primary" onClick={() => checkAllEducations(resume.isEducationChecked ? 'UNCHECK' : 'CHECK')} />
                                                        <Wmbutton className="px-4 rounded ml-2 text-sm" label={'Previous'} type="button" color="primary" onClick={() => history.push(`/editresume/${encode('about-me')}`)} />
                                                        <Wmbutton className="px-4 rounded ml-2 text-sm" label={'Next'} type="button" color="primary" onClick={() => history.push(`/editresume/${encode('work')}`)} />
                                                    </div>
                                                </div>
                                            </Col>
                                            {resume.education.length > 0 ? resume.education.map((eucationData, idx) => {
                                                return <Col sm={12} md={6} className="mb-3" key={idx}>
                                                    <ResumeFields label={`e1${idx}`} checked={eucationData.status} onCheckChange={() => checkEducations(idx)}>
                                                        <span className="manpro font-semibold text-lg block">{eucationData.edu_data.institute_name}</span>
                                                        <span className="manpro font-medium text-base block">{eucationData.edu_data.course_title}</span>
                                                        <span className="manpro font-regular text-sm block">
                                                            <Moment format={"YYYY"}>
                                                                {eucationData.edu_data.start_date}
                                                            </Moment> - <Moment format={"YYYY"}>
                                                                {eucationData.edu_data.end_date}
                                                            </Moment>
                                                        </span>
                                                    </ResumeFields>
                                                </Col>
                                            }) : <Col md={12}><div><span>No Education Data Found </span></div></Col>}
                                        </Row>
                                    </TabPanel>
                                    <TabPanel>
                                        <Row className="mb-8 mt-10">
                                            <Col md={12} className="mb-3">
                                                <div className="border-b border-gray-400 border-solid flex pb-3 justify-between items-start md:items-center space-y-5 md:space-y-0 flex-col md:flex-row">

                                                    <div>
                                                        <span className="md:text-3xl manpro block text-gray-700 font-semibold text-2xl leading-8">Work Experience
                                                        </span>
                                                        <span className='text-xs md:text-sm text-gray-700 '>Please select the fields need to be displayed on the resume</span>
                                                    </div>
                                                    <div>
                                                        <Wmbutton className="px-4 rounded ml-0 md:ml-0 text-sm" label={resume.isWorkChecked ? 'Unselect all' : 'Select all'} type="button" color="primary" onClick={() => checkAllWorks(resume.isWorkChecked ? 'UNCHECK' : 'CHECK')} />
                                                        <Wmbutton className="px-4 rounded ml-2 text-sm" label={'Previous'} type="button" color="primary" onClick={() => history.push(`/editresume/${encode('education')}`)} />
                                                        <Wmbutton className="px-4 rounded ml-2 text-sm" label={'Next'} type="button" color="primary" onClick={() => history.push(`/editresume/${encode('books')}`)} />
                                                    </div>
                                                </div>
                                            </Col>
                                            {resume.work.length > 0 ? resume.work.map((workData, idx) => {
                                                return <Col sm={12} md={6} key={idx} className="mb-3">
                                                    <ResumeFields label={`w1${idx}`} checked={workData.status} onCheckChange={() => checkWorks(idx)}>
                                                        <span className="manpro font-semibold text-lg block">{workData.work_data.work_title}</span>
                                                        <span className="manpro font-medium text-base block">{workData.work_data.work_company} - {workData.work_data.employment_type}</span>
                                                        <span className="manpro font-regular text-sm block">
                                                            <Moment format={"YYYY"}>
                                                                {workData.work_data.start_date}
                                                            </Moment> - {workData.work_data.end_date === null || workData.work_data.currently_working === "1" ? "Present" : <Moment format={"YYYY"}>
                                                                {workData.work_data.end_date}
                                                            </Moment>}
                                                        </span>
                                                    </ResumeFields>
                                                </Col>
                                            }) : <Col md={12}><div><span>No Work Details Found </span></div></Col>}
                                        </Row>
                                    </TabPanel>
                                    <TabPanel>
                                        <Row className="mb-8 mt-10">
                                            <Col md={12} className="mb-3">
                                                <div className="border-b border-gray-400 border-solid flex pb-3 justify-between items-start md:items-center space-y-5 md:space-y-0 flex-col md:flex-row">

                                                    <div>
                                                        <span className="md:text-3xl manpro block text-gray-700 font-semibold text-2xl leading-8">Publication & Books
                                                        </span>
                                                        <span className='text-xs md:text-sm text-gray-700 '>Please select the fields need to be displayed on the resume</span>
                                                    </div>
                                                    <div>
                                                        <Wmbutton className="px-4 rounded ml-0 md:ml-0 text-sm" label={resume.ispublicationChecked ? 'Unselect all' : 'Select all'} type="button" color="primary" onClick={() => checkAllPublications(resume.ispublicationChecked ? 'UNCHECK' : 'CHECK')} />
                                                        <Wmbutton className="px-4 rounded ml-2 text-sm" label={'Previous'} type="button" color="primary" onClick={() => history.push(`/editresume/${encode('work')}`)} />
                                                        <Wmbutton className="px-4 rounded ml-2 text-sm" label={'Next'} type="button" color="primary" onClick={() => history.push(`/editresume/${encode('certificate')}`)} />
                                                    </div>
                                                </div>
                                            </Col>
                                            {resume.publication.length > 0 ? resume.publication.map((publicationData, idx) => {
                                                return <Col sm={12} md={6} className="mb-3" key={idx} >
                                                    <ResumeFields label={`p1${idx}`} checked={publicationData.status} onCheckChange={() => checkPublics(idx)}>
                                                        <span className="manpro font-semibold text-lg block break-words">{publicationData.publication_data.title}</span>
                                                        <span className="manpro font-medium block break-words text-sm">{publicationData.publication_data.publication_url}</span>
                                                        <span className="manpro font-regular text-sm block">
                                                            <Moment format={"YYYY"}>{publicationData.publication_data.dop}</Moment>
                                                        </span>
                                                    </ResumeFields>
                                                </Col>
                                            }) : <Col md={12}><div><span>No Publications Found </span></div></Col>}
                                        </Row>
                                    </TabPanel>
                                    <TabPanel>
                                        <Row className="mb-8 mt-10">
                                            <Col md={12} className="mb-3">
                                                <div className="border-b border-gray-400 border-solid flex pb-3 justify-between items-start md:items-center space-y-5 md:space-y-0 flex-col md:flex-row">

                                                    <div>
                                                        <span className="md:text-3xl manpro block text-gray-700 font-semibold text-2xl leading-8">Certificate
                                                        </span>
                                                        <span className='text-xs md:text-sm text-gray-700 '>Please select the fields need to be displayed on the resume</span>
                                                    </div>
                                                    <div>
                                                        <Wmbutton className="px-4 rounded ml-0 md:ml-0 text-sm" label={resume.isCretificateChecked ? 'Unselect all' : 'Select all'} type="button" color="primary" onClick={() => checkAllCertificates(resume.isCretificateChecked ? 'UNCHECK' : 'CHECK')} />
                                                        <Wmbutton className="px-4 rounded ml-2 text-sm" label={'Previous'} type="button" color="primary" onClick={() => history.push(`/editresume/${encode('books')}`)} />
                                                        <Wmbutton className="px-4 rounded ml-2 text-sm" label={'Next'} type="button" color="primary" onClick={() => history.push(`/editresume/${encode('extra-curricular')}`)} />
                                                    </div>
                                                </div>
                                            </Col>
                                            {resume.certificate.length > 0 ? resume.certificate.map((certData, idx) => {
                                                return <Col sm={12} md={6} className="mb-3" key={idx} >
                                                    <ResumeFields label={`cr1${idx}`} checked={certData.status} onCheckChange={() => checkCerts(idx)}>
                                                        <span className="manpro font-semibold text-lg block break-words">{certData.certificate_data.title}</span>
                                                        <span className="manpro font-medium block break-words text-sm">{certData.certificate_data.certificate_url}</span>
                                                        <span className="manpro font-regular text-sm block">
                                                            <Moment format={"YYYY"}>{certData.certificate_data.date}</Moment>
                                                        </span>
                                                    </ResumeFields>
                                                </Col>
                                            }) : <Col md={12}><div><span>No Certificate Found </span></div></Col>}
                                        </Row>
                                    </TabPanel>
                                    <TabPanel>
                                        <Row className="mb-8 mt-10">
                                            <Col md={12} className="mb-3">
                                                <div className="border-b border-gray-400 border-solid flex pb-3 justify-between items-start md:items-center space-y-5 md:space-y-0 flex-col md:flex-row">

                                                    <div>
                                                        <span className="md:text-3xl manpro block text-gray-700 font-semibold text-2xl leading-8">Extra curricular
                                                        </span>
                                                        <span className='text-xs md:text-sm text-gray-700 '>Please select the fields need to be displayed on the resume</span>
                                                    </div>
                                                    <div>
                                                        <Wmbutton className="px-4 rounded ml-0 md:ml-0 text-sm" label={resume.isExtracurChecked ? 'Unselect all' : 'Select all'} type="button" color="primary" onClick={() => checkAllExtras(resume.isExtracurChecked ? 'UNCHECK' : 'CHECK')} />
                                                        <Wmbutton className="px-4 rounded ml-2 text-sm" label={'Previous'} type="button" color="primary" onClick={() => history.push(`/editresume/${encode('certificate')}`)} />
                                                        <Wmbutton className="px-4 rounded ml-2 text-sm" label={'Next'} type="button" color="primary" onClick={() => history.push(`/editresume/${encode('projects')}`)} />
                                                    </div>
                                                </div>
                                            </Col>
                                            {resume.extracur.length > 0 ? resume.extracur.map((extraData, idx) => {
                                                return <Col sm={12} md={6} className="mb-3" key={idx}>
                                                    <ResumeFields label={`e1${idx}`} checked={extraData.status} onCheckChange={() => checkExtras(idx)}>
                                                        <span className="manpro font-semibold text-lg block">{extraData.extracuricular_data.title}</span>
                                                        <span className="manpro font-medium text-base block">{extraData.extracuricular_data.description}</span>
                                                        <span className="manpro font-regular text-sm block">
                                                            <Moment format={"YYYY"}>
                                                                {extraData.extracuricular_data.start_date}
                                                            </Moment> - <Moment format={"YYYY"}>
                                                                {extraData.extracuricular_data.end_date}
                                                            </Moment>
                                                        </span>
                                                    </ResumeFields>
                                                </Col>
                                            }) : <Col md={12}><div><span>No Extra Curr Data Found </span></div></Col>}
                                        </Row>
                                    </TabPanel>
                                    <TabPanel>
                                        <Row className="mb-8 mt-10">
                                            <Col md={12} className="mb-3">
                                                <div className="border-b border-gray-400 border-solid flex pb-3 justify-between items-start md:items-center space-y-5 md:space-y-0 flex-col md:flex-row">

                                                    <div>
                                                        <span className="md:text-3xl manpro block text-gray-700 font-semibold text-2xl leading-8">Projects
                                                        </span>
                                                        <span className='text-xs md:text-sm text-gray-700 '>Please select the fields need to be displayed on the resume</span>
                                                    </div>
                                                    <div>
                                                        <Wmbutton className="px-4 rounded ml-0 md:ml-0 text-sm" label={resume.isProjectChecked ? 'Unselect all' : 'Select all'} type="button" color="primary" onClick={() => checkAllProjects(resume.isProjectChecked ? 'UNCHECK' : 'CHECK')} />
                                                        <Wmbutton className="px-4 rounded ml-2 text-sm" label={'Previous'} type="button" color="primary" onClick={() => history.push(`/editresume/${encode('extra-curricular')}`)} />
                                                        <Wmbutton className="px-4 rounded ml-2 text-sm" label={'Next'} type="button" color="primary" onClick={() => history.push(`/editresume/${encode('hobbies')}`)} />
                                                    </div>
                                                </div>
                                            </Col>
                                            {resume.projects.length > 0 ? resume.projects.map((projectdata, idx) => {
                                                return <Col sm={12} md={6} key={idx} className="mb-3">
                                                    <ResumeFields label={`pr1${idx}`} checked={projectdata.status} onCheckChange={() => checkProjects(idx)}>
                                                        <span className="manpro font-semibold text-lg block">{projectdata.projects_data.title}</span>
                                                        <span className="manpro font-medium text-base block">{projectdata.projects_data.project_url}</span>
                                                        <span className="manpro font-regular text-sm block">
                                                            <Moment format={"YYYY"}>
                                                                {projectdata.projects_data.start_date}
                                                            </Moment> - {projectdata.projects_data.end_date === null || projectdata.projects_data.currently_working === "1" ? "Present" : <Moment format={"YYYY"}>
                                                                {projectdata.projects_data.end_date}
                                                            </Moment>}
                                                        </span>
                                                    </ResumeFields>
                                                </Col>
                                            }) : <Col md={12}><div><span>No Projects Found </span></div></Col>}
                                        </Row>
                                    </TabPanel>
                                    <TabPanel>
                                        <Row className="mt-10">
                                            <Col md={12} className="mb-3">
                                                <div className="mb-3 flex justify-between border-b border-gray-400 border-solid pb-3 flex-col md:flex-row space-y-5 md:space-y-0">
                                                    <span className="manpro text-gray-700 font-semibold text-2xl md:text-3xl block">
                                                        Hobbies and interests
                                                    </span>
                                                    <div>
                                                        <Wmbutton className="px-4 text-sm rounded ml-0 md:ml-0" label={'Previous'} type="button" color="primary" onClick={() => history.push(`/editresume/${encode('projects')}`)} />
                                                        <Wmbutton className="px-4 rounded ml-2" label={'Next'} type="button" color="primary" onClick={() => history.push(`/editresume/${encode('skills')}`)} />
                                                    </div>
                                                </div>
                                            </Col>

                                            <Col md={12}>
                                                <div className="row mx-0">
                                                    {resume.hobbies.map((data, idx) => {
                                                        return <HobbiesPills key={idx} data={data} id={idx} />
                                                    })}
                                                </div>
                                            </Col>
                                            <Hobbies onHandleHobby={(value) => handleAddHobbies(value)} />
                                        </Row>
                                    </TabPanel>
                                    <TabPanel>
                                        <Row className="mt-10">
                                            <Col md={12} className="mb-3">
                                                <div className="mb-3 flex justify-between border-b border-gray-400 border-solid pb-3 flex-col md:flex-row space-y-5 md:space-y-0">
                                                    <span className="manpro text-gray-700 font-semibold text-2xl md:text-3xl block">
                                                        Skills
                                                    </span>
                                                    <div>
                                                        <Wmbutton className="px-4 text-sm rounded ml-0" label={'Previous'} type="button" color="primary" onClick={() => history.push(`/editresume/${encode('hobbies')}`)} />
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={12}>
                                                <div className="row mx-0">
                                                    {resume.skills.map((data, idx) => {
                                                        return <SkillPills data={data} key={idx} id={idx} />
                                                    })}
                                                </div>
                                            </Col>
                                            <Skills handleAddSkillData={(data) => handleAddSkills(data)} />
                                        </Row>
                                    </TabPanel>
                                </div>
                            </div>
                        </div>
                    </div>
                </Tabs>}
            <WmModals show={isDeleteResumeModal} onHide={() => setDeleteResumeModal(false)} size="md" className="">
                <Container fluid className="py-4">
                    <Row>
                        <Col md={12}>
                            <div className="text-center mb-4">
                                <span className="block">
                                    Are you sure you want to Delete the Resume
                                </span>
                                <span className="block">
                                    This will erase all above content permenantly!!!!
                                </span>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="text-right">
                                <Wmbutton
                                    label={
                                        isDeleting ? (
                                            <CircularProgress className="loader_size_xsm text-white" />
                                        ) : (
                                            "Delete"
                                        )
                                    }
                                    className="rounded w-20 mr-3"
                                    type="button"
                                    size="sm"
                                    color="danger"
                                    onClick={() => { deleteResumeModal() }}
                                />
                                <Wmbutton
                                    label="Cancel"
                                    className="rounded w-20"
                                    type="button"
                                    color="primary"
                                    onClick={() => { setDeleteResumeModal(false) }}
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </WmModals>
        </div>
    )
}

const mapStateToProps = (state) => {
    return state;
};

const mapDispatchToState = (dispatch) => {
    return {
        getResumeDatas: (value) => {
            dispatch(setResumeDataEdit(value))
        },
        addSkill: () => {
            dispatch(addSkills())
        },
        addSkillsTitles: (id, value) => {
            dispatch(addSkillsTitle(id, value))
        },
        addSkillsRanges: (id, value) => {
            dispatch(addSkillsRange(id, value))
        },
        skillsResets: (id) => {
            dispatch(skillsReset(id))
        },
        skillsDeletes: (id) => {
            dispatch(skillsDelete(id))
        },
        checkProfiles: () => {
            dispatch(checkProfile())
        },
        checkBios: () => {
            dispatch(checkBio())
        },
        checkFullNames: () => {
            dispatch(checkFullName())
        },
        checkAddresss: () => {
            dispatch(checkAddress())
        },
        checkPhones: () => {
            dispatch(checkPhone())
        },
        checkEmails: () => {
            dispatch(checkEmail())
        },
        checkFbs: () => {
            dispatch(checkFb())
        },
        checkLinkds: () => {
            dispatch(checkLinkd())
        },
        checkTws: () => {
            dispatch(checkTw())
        },
        checkDribs: () => {
            dispatch(checkDrib())
        },
        checkBes: () => {
            dispatch(checkBe())
        },
        checkPins: () => {
            dispatch(checkPin())
        },
        checkInstas: () => {
            dispatch(checkInsta())
        },
        checkYts: () => {
            dispatch(checkYt())
        },
        checkEducations: (value) => {
            dispatch(checkEducation(value))
        },
        checkWorks: (value) => {
            dispatch(checkWork(value))
        },
        checkPublics: (value) => {
            dispatch(checkPublic(value))
        },
        checkCerts: (value) => {
            dispatch(checkCert(value))
        },
        checkExtras: (value) => {
            dispatch(checkExtra(value))
        },
        checkProjects: (value) => {
            dispatch(checkProject(value))
        },
        checkAllPersonalDetails: (action) => {
            dispatch(checkAllPersonalDetail(action))
        },
        checkAllEducations: (action) => {
            dispatch(checkAllEducation(action))
        },
        checkAllWorks: (action) => {
            dispatch(checkAllWork(action))
        },
        checkAllPublications: (action) => {
            dispatch(checkAllPublication(action))
        },
        checkAllProjects: (action) => {
            dispatch(checkAllProject(action))
        },
        handleAddHobbies: (action) => {
            dispatch(addHobbies(action))
        },
        handleAddSkills: (action) => {
            dispatch(addSkills(action))
        },
        checkAllExtras: (action) => {
            dispatch(checkAllExtra(action))
        },
        checkAllCertificates: (action) => {
            dispatch(checkAllCertificate(action))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToState)(EditResume)
